import { z } from "zod"

export const intentSchema = z.discriminatedUnion("action", [
	z.object({ action: z.literal("easy_match_search"), params: z.object({}) }),
	z.object({
		action: z.literal("social_match_search"),
		params: z.object({}),
	}),
	z.object({
		action: z.literal("card_create"),
		params: z.object({ from: z.enum(["feed", "profile"]) }),
	}),
	z.object({ action: z.literal("qotd_answer"), params: z.object({}) }),
	z.object({
		action: z.literal("social_match_confirm"),
		params: z.object({}),
	}),
	z.object({ action: z.literal("social_match_open"), params: z.object({}) }),
	z.object({ action: z.literal("easy_match_chat"), params: z.object({}) }),
])

export type Intent = z.infer<typeof intentSchema>

export function intentAction(intent: Intent | null): Intent["action"] | null {
	if (intent === null) return null
	return intent.action
}
